import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { BrandsService } from "@kno2/data-access/api-kno2fy-main";
import { MenuItem } from "primeng/api";

@Component({
    selector: "ngx-header",
    styleUrls: ["./header.component.scss"],
    templateUrl: "./header.component.html",
    standalone: false
})
export class HeaderComponent {
    @Input() public user: any;
    @Input() public dropdownItems: Array<MenuItem>;

    public logo: string | undefined;

    constructor(
        private router: Router,
        brandsService: BrandsService
    ) {
        this.logo = brandsService.webConfiguration?.images?.find((image) => image.name === "logo-dark")?.url;
    }

    public get userInitials(): string {
        return (this.user?.name ?? "")
            .split(" ")
            .map((part: string) => part.charAt(0))
            .join("")
            .slice(0, 2)
            .toUpperCase();
    }

    public navigateHome(): boolean {
        this.router.navigateByUrl("/");
        return false;
    }
}
